import React from 'react';

import {ContentBlocksRenderer} from '../../../ContentZone/student/ContentBlocksRenderer';
import {Content, ContentItemType} from '@ael/core-api';
import {FroalaEditorsSettings} from "../../../../config/configs";

type TextContentProps = {
  title: string;
  body: Content;
  contentItem: ContentItemType;
  froalaEditorsSettings: FroalaEditorsSettings;
};

export const TextContent: React.FC<TextContentProps> = (props: TextContentProps) => {
  return <ContentBlocksRenderer content={props.body} contentItem={props.contentItem} inSmallWindow={false} froalaEditorsSettings={props.froalaEditorsSettings} />;
};
